var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box",attrs:{"id":"J_prismPlayer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }